import { IPromise, IScope } from 'angular';
import { IFontFamilyModel } from '../../classes';
import { IPostTrial, ITrial, TrialService, TrialType } from '../../providers';

import template from './desktop-trial-popover-form.html';

export class DesktopTrialPopoverFormController {
    // binding: called after saving a list.
    onSubmitted?: (args: { trial: ITrial }) => void;
    // binding: styles to add to the list.
    family?: IFontFamilyModel;

    static $inject = ['trialService'];
    constructor(
        protected trialService: TrialService,
        protected $scope: IScope
    ) {}

    submit(): IPromise<void> | void {
        if (!this.family) return;
        const data: IPostTrial = {
            family_id: this.family?.id,
            trial_type: TrialType.DESKTOP,
        };
        // do the thing.
        this.trialService.post(data).then((trial) => {
            this.onSubmitted && this.onSubmitted({ trial });
        }).catch((err) => {
            console.error('Error starting trial', err);
        });
    }
}

export const DesktopTrialPopoverFormComponent = {
    controller: DesktopTrialPopoverFormController,
    template,
    bindings: {
        onSubmitted: '&',
        family: '<',
    },
};
